import type { FC } from "react"
import useTheme from "theme/ThemeProvider"

import type { IBodyProps } from "./common"
import { Text } from "./common"

export const ExerciseSentence: FC<IBodyProps> = props => {
  const theme = useTheme()

  // noinspection RequiredAttributes
  return (
    <Text {...props} type={theme.typography.exerciseSentence} theme={theme} selectable={false} />
  )
}
